import React, { useState } from 'react';
import { Shield, Lock, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { useAppLock } from '../contexts/AppLockContext';
import { AppBrandLogo } from '../components/AppBrandLogo';

const AppUnlockPage = () => {
  const { unlock, unlocking, error } = useAppLock();
  const [passphrase, setPassphrase] = useState('');

  const wordCount = passphrase.trim() ? passphrase.trim().split(/\s+/).length : 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    await unlock(passphrase);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-lg space-y-6">
        <div className="flex flex-col items-center text-center space-y-3">
          <AppBrandLogo banner className="w-full" />
          <div className="flex items-center gap-2 text-primary">
            <Shield className="w-6 h-6" />
            <h1 className="text-2xl font-bold tracking-tight">Secure access</h1>
          </div>
          <p className="text-muted-foreground text-sm max-w-md">
            Admin tools are protected separately from customer login. Enter the
            32-word master security passphrase provided by your organization.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 rounded-xl border bg-card p-6 shadow-sm">
          <label className="text-sm font-medium flex items-center gap-2">
            <Lock className="w-4 h-4" />
            Master passphrase (32 words)
          </label>
          <Textarea
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
            placeholder="word1 word2 word3 ... (32 words total)"
            rows={5}
            className="font-mono text-sm"
            autoComplete="off"
            spellCheck={false}
          />
          <p className="text-xs text-muted-foreground">
            Words entered: {wordCount} / 32
          </p>
          {error && (
            <p className="text-sm text-destructive" role="alert">
              {error}
            </p>
          )}
          <Button type="submit" className="w-full" disabled={unlocking || !passphrase.trim()}>
            {unlocking ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Verifying…
              </>
            ) : (
              'Unlock application'
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AppUnlockPage;
